import { render, staticRenderFns } from "./bp.vue?vue&type=template&id=274c94f6&scoped=true&"
import script from "./bp.vue?vue&type=script&lang=js&"
export * from "./bp.vue?vue&type=script&lang=js&"
import style0 from "./bp.vue?vue&type=style&index=0&id=274c94f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c94f6",
  null
  
)

export default component.exports